var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path21, _path22, _ellipse, _path23, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPirates26(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#592820;}.cls-2{fill:#fec64b;}.cls-3{fill:#c99735;}.cls-4{fill:#ea800f;}.cls-5{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pirates") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.45,45.79v67.13a9.53,9.53,0,0,0-9.53,9.53V428.94a59.63,59.63,0,0,0-20.55,0V122.46a9.53,9.53,0,0,0-9.53-9.53V45.79A19.81,19.81,0,0,1,602.45,45.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602.45,859.77V926.9a19.81,19.81,0,0,1-39.62,0V859.77a9.52,9.52,0,0,0,9.53-9.52V545a59.65,59.65,0,0,0,20.55,0V850.25A9.52,9.52,0,0,0,602.45,859.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1043,486.36a19.79,19.79,0,0,1-19.79,19.79H956.06a9.52,9.52,0,0,0-9.52-9.52H640.78a58,58,0,0,0,.79-9.65,59.4,59.4,0,0,0-1-10.92h306a9.52,9.52,0,0,0,9.52-9.52h67.15A19.8,19.8,0,0,1,1043,486.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.71,487a58,58,0,0,0,.79,9.65H218.74a9.52,9.52,0,0,0-9.52,9.52H142.08a19.8,19.8,0,0,1,0-39.6h67.15a9.52,9.52,0,0,0,9.52,9.52h306A59.4,59.4,0,0,0,523.71,487Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M908.16,811.87a19.8,19.8,0,0,1-28,0L832.69,764.4a9.52,9.52,0,0,0,0-13.47L616.78,535a59.08,59.08,0,0,0,14.42-14.67L660.86,550,847.23,736.38a9.49,9.49,0,0,0,13.47,0l47.47,47.48A19.77,19.77,0,0,1,908.16,811.87Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M549.25,438.41a59.65,59.65,0,0,0-14.66,14.44L318.06,236.31a9.52,9.52,0,0,0-13.47,0l-47.47-47.47a19.81,19.81,0,0,1,28-28l47.47,47.47a9.52,9.52,0,0,0,0,13.47Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548.51,535L332.6,750.94a9.52,9.52,0,0,0,0,13.47l-47.47,47.47a19.8,19.8,0,0,1-28-28l47.47-47.48a9.49,9.49,0,0,0,13.47,0L504.43,550l29.66-29.66A59.08,59.08,0,0,0,548.51,535Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M908.16,188.84l-47.47,47.47a9.52,9.52,0,0,0-13.47,0L630.69,452.85A59.65,59.65,0,0,0,616,438.41L832.69,221.75a9.52,9.52,0,0,0,0-13.47l47.47-47.47A19.81,19.81,0,0,1,908.16,188.84Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M601.85,169.35H564.26a13.42,13.42,0,1,0,0,26.85h37.59A13.42,13.42,0,0,0,601.85,169.35Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.66,252.06l-26.58,26.58a13.42,13.42,0,0,0,19,19L392.64,271A13.42,13.42,0,0,0,373.66,252.06Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.14,468.19v37.59a13.42,13.42,0,1,0,26.85,0V468.19A13.42,13.42,0,0,0,269.14,468.19Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M349,694l26.58,26.58a13.42,13.42,0,0,0,19-19L368,675.06A13.42,13.42,0,0,0,349,694Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M568.39,803H606a13.42,13.42,0,0,0,0-26.85H568.39A13.42,13.42,0,0,0,568.39,803Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M798.24,724.11l26.58-26.58a13.42,13.42,0,1,0-19-19l-26.58,26.58A13.42,13.42,0,1,0,798.24,724.11Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M904.41,500.41V462.82a13.42,13.42,0,1,0-26.85,0v37.59A13.42,13.42,0,0,0,904.41,500.41Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M821.69,272.21l-26.58-26.58a13.42,13.42,0,0,0-19,19l26.58,26.58A13.42,13.42,0,1,0,821.69,272.21Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M582.64,192.76c-162.49,0-294.22,131.73-294.22,294.22S420.15,781.2,582.64,781.2,876.86,649.47,876.86,487,745.13,192.76,582.64,192.76Zm0,505.08c-116.46,0-210.86-94.41-210.86-210.86s94.41-210.86,210.86-210.86S793.5,370.52,793.5,487,699.1,697.84,582.64,697.84Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M682.52,476.06a100.58,100.58,0,0,0-89.6-89c-3.39-.33-6.81-0.51-10.28-0.51s-6.89.18-10.28,0.51a100.48,100.48,0,0,0-90.19,100q0,4.88.46,9.65A99.88,99.88,0,0,0,504.43,550a100.33,100.33,0,0,0,67.94,36.91c3.39,0.33,6.81.51,10.28,0.51s6.89-.18,10.28-0.51a100.54,100.54,0,0,0,89.73-90.29q0.47-4.76.46-9.65A99.43,99.43,0,0,0,682.52,476.06Zm-51.32,44.3A59.08,59.08,0,0,1,616.78,535h0a58.55,58.55,0,0,1-23.84,10,59.65,59.65,0,0,1-20.55,0,58.55,58.55,0,0,1-23.84-10h0a59.08,59.08,0,0,1-14.42-14.67A58.78,58.78,0,0,1,523.71,487a59.4,59.4,0,0,1,1-10.92,58.77,58.77,0,0,1,9.88-23.21,59.65,59.65,0,0,1,14.66-14.44,58.7,58.7,0,0,1,23.11-9.47,59.63,59.63,0,0,1,20.55,0A58.7,58.7,0,0,1,616,438.41a59.65,59.65,0,0,1,14.66,14.44,58.77,58.77,0,0,1,9.88,23.21,59.4,59.4,0,0,1,1,10.92A58.78,58.78,0,0,1,631.2,520.36Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M582.64,787c-165.42,0-300-134.58-300-300s134.58-300,300-300,300,134.58,300,300S748.06,787,582.64,787Zm0-588.43c-159,0-288.43,129.39-288.43,288.43S423.6,775.42,582.64,775.42,871.08,646,871.08,487,741.69,198.55,582.64,198.55Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M582.64,703.62C463.18,703.62,366,606.44,366,487s97.19-216.64,216.64-216.64S799.29,367.52,799.29,487,702.1,703.62,582.64,703.62Zm0-421.72c-113.08,0-205.08,92-205.08,205.08s92,205.08,205.08,205.08,205.08-92,205.08-205.08S695.72,281.9,582.64,281.9Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 583.06,
    cy: 236.16,
    r: 13.22,
    transform: "translate(49.29 569.05) rotate(-54)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 457.59,
    cy: 269.55,
    r: 13.22,
    transform: "translate(141.68 696.46) rotate(-84)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 365.63,
    cy: 361.21,
    r: 13.22,
    transform: "translate(-115.31 179.94) rotate(-24)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 331.82,
    cy: 486.57,
    r: 13.22,
    transform: "translate(-256.86 469.02) rotate(-54)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 365.22,
    cy: 612.03,
    r: 13.22,
    transform: "translate(-281.64 911.28) rotate(-84)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 456.87,
    cy: 703.99,
    r: 13.22,
    transform: "translate(-246.84 246.69) rotate(-24)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 582.23,
    cy: 737.8,
    r: 13.22,
    transform: "translate(-356.89 775.17) rotate(-54)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 707.7,
    cy: 704.41,
    r: 13.22,
    transform: "translate(-66.83 1334.6) rotate(-84)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 799.66,
    cy: 612.75,
    r: 13.22,
    transform: "translate(-180.09 378.22) rotate(-24)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 833.47,
    cy: 487.39,
    r: 13.22,
    transform: "translate(-50.74 875.2) rotate(-54)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 800.07,
    cy: 361.93,
    r: 13.22,
    transform: "translate(356.5 1119.78) rotate(-84)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 708.41,
    cy: 269.97,
    r: 13.22,
    transform: "translate(-48.56 311.48) rotate(-24)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M582.64,553.34A66.36,66.36,0,1,1,649,487,66.43,66.43,0,0,1,582.64,553.34Zm0-117.84A51.49,51.49,0,1,0,634.13,487,51.54,51.54,0,0,0,582.64,435.49Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M523.86,422c4,1.5-6.63,16.36-15,37.74-8.61,21.29-11.13,39.37-15,37.73-3.72-1.4-7.38-21.94,1.22-43.23C503.42,432.89,520.19,420.48,523.86,422Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 498.7,
    cy: 515.11,
    rx: 5.57,
    ry: 12.37,
    transform: "translate(-152.34 214.79) rotate(-21.16)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M787,318c-20.31-24.86-43.1-47.14-41.12-49.78,1.73-2.8,29.65,14.49,52.53,39.44,23.13,25,30.53,46.42,26.24,48.93C820.09,359.22,807.56,342.81,787,318Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 734.14,
    cy: 258.79,
    rx: 4.92,
    ry: 11.07,
    transform: "translate(82.65 684.82) rotate(-52.6)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirates26);
export default __webpack_public_path__ + "static/media/pirates-26.b38bcb201e6124c5d8f69b53b6b00f88.svg";
export { ForwardRef as ReactComponent };